import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useAuth as useAuthHook } from '../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  
  // First try to use AuthContext if available
  let contextAuth;
  try {
    contextAuth = useAuth();
  } catch (e) {
    // If AuthContext is not available, fall back to the hook
    console.log('AuthContext not available, using hook instead');
    contextAuth = null;
  }
  
  // Use the hook as fallback
  const hookAuth = useAuthHook();
  
  // Combine authentication data, preferring context when available
  const auth = contextAuth || hookAuth;
  const { isAuthenticated, loading: isLoading } = auth;

  if (isLoading) {
    // Show loading indicator while checking authentication status
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login if not authenticated, passing the current location
    // so we can redirect back after login
    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }

  // Render the protected component if authenticated
  return <>{children}</>;
};

export default ProtectedRoute;
